import { useState } from "react";
import Dialog from "components/Overlays/ResponsiveDialog";
import { FiTrash2 } from "react-icons/fi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import useDeleteTag from "api/TagResource/useDeleteTag";

export default function TagDeleteDialog({ tag, visible, onHide }) {
	const { mutateAsync, isLoading } = useDeleteTag(tag.id);
	const [error, setError] = useState("");
	const inUse = Number(tag.books_count || 0) > 0;
	const remove = async () => {
		if (inUse || isLoading) return;
		setError("");
		try { await mutateAsync(); onHide(); }
		catch { setError("This tag couldn’t be deleted. Please try again."); }
	};
	return <Dialog visible={visible} onHide={onHide} sheet={false} header="Delete tag?" icon={<FiTrash2 />}
		description="Remove an unused tag from your library." className="tag-delete-dialog" style={{ width: "28rem" }}
		modal closable={!isLoading} closeOnEscape={!isLoading}
		footer={<div className="tag-delete-actions"><button type="button" className="akello-action" disabled={isLoading} onClick={onHide}>Keep tag</button>
			<button type="button" className="akello-action tag-danger-button" disabled={isLoading || inUse} onClick={remove}>
				{isLoading ? <AiOutlineLoading3Quarters className="animate-spin" aria-hidden="true" /> : <FiTrash2 aria-hidden="true" />}{isLoading ? "Deleting…" : "Delete tag"}</button></div>}>
		<p className="tag-delete-copy">Delete <strong>“{tag.name}”</strong>? This action cannot be undone.</p>
		{inUse && <p className="akello-form-error" role="alert">This tag is now linked to books and cannot be deleted.</p>}
		{error && <p className="akello-form-error" role="alert">{error}</p>}
	</Dialog>;
}
